const DEFAULT_ZOOM = 16;

export const mapExtentStore = $state({
	viewBounds: undefined as [number, number, number, number] | undefined,
	zoom: DEFAULT_ZOOM,
	// Bumped on map `idle` so `queryRenderedFeatures` readers re-query once tiles have loaded.
	renderTick: 0
});

/** Drop the saved extent on app switch so the next Map mount auto-zooms to the new app's data. */
export function resetMapExtent() {
	mapExtentStore.viewBounds = undefined;
	mapExtentStore.zoom = DEFAULT_ZOOM;
}
